'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosChatboxesOutline = function IoIosChatboxesOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm4.8 5v15h7.5v1.3h-8.8v-17.5h22.5v8.7h-1.2v-7.5h-20z m8.7 8.8h22.5v17.5h-3.7v5h-1.1l-5-5h-12.7v-17.5z m21.3 16.2v-15h-20v15h11.9l4.3 4.3v-4.3h3.8z' })
        )
    );
};

exports.default = IoIosChatboxesOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-chatboxes-outline.js
// module id = 2587
// module chunks = 168707334958949